import React from "react";
import "./ImageResponsive.css";

interface ImageResponsiveProps {
  alt: string;
  src: string;
  screenStyles?: React.CSSProperties;
}

const ImageResponsive = (props: ImageResponsiveProps) => {
  const { alt, src, screenStyles } = props;
  return (
    <img style={screenStyles} className="imageResponsive" alt={alt} src={src} />
  );
};

export default ImageResponsive;
